/*
 * Yafeapedia
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.64
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ArticleDTO from './ArticleDTO';
import PageableObject from './PageableObject';
import SortObject from './SortObject';

/**
 * The PageArticleDTO model module.
 * @module model/PageArticleDTO
 * @version 1.0.1
 */
export default class PageArticleDTO {
  /**
   * Constructs a new <code>PageArticleDTO</code>.
   * @alias module:model/PageArticleDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PageArticleDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PageArticleDTO} obj Optional instance to populate.
   * @return {module:model/PageArticleDTO} The populated <code>PageArticleDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PageArticleDTO();
      if (data.hasOwnProperty('totalElements'))
        obj.totalElements = ApiClient.convertToType(data['totalElements'], 'Number');
      if (data.hasOwnProperty('totalPages'))
        obj.totalPages = ApiClient.convertToType(data['totalPages'], 'Number');
      if (data.hasOwnProperty('size'))
        obj.size = ApiClient.convertToType(data['size'], 'Number');
      if (data.hasOwnProperty('content'))
        obj.content = ApiClient.convertToType(data['content'], [ArticleDTO]);
      if (data.hasOwnProperty('number'))
        obj._number = ApiClient.convertToType(data['number'], 'Number');
      if (data.hasOwnProperty('sort'))
        obj.sort = SortObject.constructFromObject(data['sort']);
      if (data.hasOwnProperty('first'))
        obj.first = ApiClient.convertToType(data['first'], 'Boolean');
      if (data.hasOwnProperty('last'))
        obj.last = ApiClient.convertToType(data['last'], 'Boolean');
      if (data.hasOwnProperty('numberOfElements'))
        obj.numberOfElements = ApiClient.convertToType(data['numberOfElements'], 'Number');
      if (data.hasOwnProperty('pageable'))
        obj.pageable = PageableObject.constructFromObject(data['pageable']);
      if (data.hasOwnProperty('empty'))
        obj.empty = ApiClient.convertToType(data['empty'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Number} totalElements
 */
PageArticleDTO.prototype.totalElements = undefined;

/**
 * @member {Number} totalPages
 */
PageArticleDTO.prototype.totalPages = undefined;

/**
 * @member {Number} size
 */
PageArticleDTO.prototype.size = undefined;

/**
 * @member {Array.<module:model/ArticleDTO>} content
 */
PageArticleDTO.prototype.content = undefined;

/**
 * @member {Number} _number
 */
PageArticleDTO.prototype._number = undefined;

/**
 * @member {module:model/SortObject} sort
 */
PageArticleDTO.prototype.sort = undefined;

/**
 * @member {Boolean} first
 */
PageArticleDTO.prototype.first = undefined;

/**
 * @member {Boolean} last
 */
PageArticleDTO.prototype.last = undefined;

/**
 * @member {Number} numberOfElements
 */
PageArticleDTO.prototype.numberOfElements = undefined;

/**
 * @member {module:model/PageableObject} pageable
 */
PageArticleDTO.prototype.pageable = undefined;

/**
 * @member {Boolean} empty
 */
PageArticleDTO.prototype.empty = undefined;

